import { ElementProps } from '@mantine/core';
import clsx from 'clsx';
import { useUnit } from 'effector-react';
import { forwardRef } from 'react';
import { ModalFormModel } from 'shared/lib';

export type ModalFormFormProps = ElementProps<'form', 'onSubmit'>;

export const createModalFormForm = <TModalData, TFormValues extends Record<string, unknown>>(
	modalFormModel: ModalFormModel<TModalData, TFormValues>,
) => {
	const ModalFormForm = forwardRef<HTMLFormElement, ModalFormFormProps>(
		({ className, children, ...props }, ref) => {
			const submit = useUnit(modalFormModel.form.submit);

			return (
				<form
					ref={ref}
					data-test-id='modal-form-form'
					className={clsx('modal-form-form', className)}
					onSubmit={(event) => {
						event.preventDefault();
						submit();
					}}
					{...props}
				>
					{children}
				</form>
			);
		},
	);

	return ModalFormForm;
};
